import { BidStatus } from './enums/BidStatus'
import { Job } from './Job'
import { Slots } from './SetAvailability'
export class Bid {
    jobId: string
    bid: number
    haulerId: string
    createDate?: number
    status?: BidStatus
    modifyDate?: number
    message?: string
    job: Job
    isGoTrashyChoice?: boolean
    hauler?: {
        avatar?: string
        rating?: number
        numberCompliments?: number
    }
    timeSlot: Slots
}



// WEBPACK FOOTER //
// ./src/types/Bid.ts